/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Await_Print_Customer_LabelInputs */

const vi_await_print_customer_label = /** @type {(inputs: Await_Print_Customer_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Khách hàng`)
};

/**

* @param {Await_Print_Customer_LabelInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const await_print_customer_label = /** @type {((inputs?: Await_Print_Customer_LabelInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Await_Print_Customer_LabelInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_await_print_customer_label(inputs)
});